import StoreAction from "./StoreAction";
import { useLocalObservable } from "mobx-react-lite";

const initialState = {
  selectedObject1: [],
  selectedObject2: [],
  role: "學生",
};
const ExploreStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
  }));

  return store;
};

export default ExploreStore;
